// Kept here, not in components/brief/index.js: the other components in this pack may
// rely on the polyfill, while onboarding_components (brief only) targets browsers
// that don't need it.
import 'babel-polyfill';
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);



// WEBPACK FOOTER //
// ./app/javascript/packs/small_components.js